// extracted by mini-css-extract-plugin
export default {"marked":"style_marked__k7UrI"};